/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { checkIsActive } from "../../../../_helpers";
import low from "lowdb";
import LocalStorage from "lowdb/adapters/LocalStorage";
import { useTranslation } from "react-i18next";
import KTLayoutHeaderMenu from "../../../../_assets/js/layout/base/header-menu";
const adapter = new LocalStorage("db");
const db = low(adapter);

export function HeaderMenu({ layoutProps }) {
  useEffect(() => {
    KTLayoutHeaderMenu.init("kt_header_menu", "kt_header_menu_wrapper");
  }, []);

  const location = useLocation();
  const { t } = useTranslation();
  const getMenuItemActive = (url) => {
    return checkIsActive(location, url) ? "menu-item-active" : "";
  };

  return (
    <div
      id="kt_header_menu"
      className={`header-menu header-menu-mobile ${layoutProps.ktMenuClasses}`}
      {...layoutProps.headerMenuAttributes}
    >
      {/*begin::Header Nav*/}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item menu-item-rel ${getMenuItemActive(
            "/dashboard"
          )}`}
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="menu-text">{t("Dashboard")}</span>
            {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
          </NavLink>
        </li>
        <li
          className={`menu-item menu-item-rel ${getMenuItemActive(
            "/shipper/Loads"
          )}`}
        >
          <NavLink className="menu-link" to="/shipper/Loads">
            <span className="menu-text">{t("My_Loads")}</span>
          </NavLink>
        </li>

        {db.read().getState()?.IsDash2Dash === "True" ? (
          <li
            className={`menu-item menu-item-rel ${getMenuItemActive(
              "/Truckers"
            )}`}
          >
            <NavLink className="menu-link" to="/Truckers">
              <span className="menu-text">{t("My_Truckers")}</span>
            </NavLink>
          </li>
        ) : (
          ""
        )}
        <li
          className={`menu-item menu-item-rel ${getMenuItemActive(
            "/Invoices"
          )}`}
        >
          <NavLink className="menu-link" to="/Invoices">
            <span className="menu-text">My invoices</span>
          </NavLink>
        </li>
        {db.read().getState()?.IsDash2Dash === "True" ? (
          <li
            data-menu-toggle={layoutProps.menuDesktopToggle}
            aria-haspopup="true"
            className={`menu-item menu-item-submenu menu-item-rel ${getMenuItemActive(
              "/custom"
            )}`}
          >
            <NavLink className="menu-link menu-toggle" to="/custom">
              <span className="menu-text">{t("Import")}</span>
              <i className="menu-arrow"></i>
            </NavLink>
            <div className="menu-submenu menu-submenu-classic menu-submenu-left">
              <ul className="menu-subnav">
                {/*begin::2 Level*/}
                <li
                  className={`menu-item ${getMenuItemActive("/ImportLoads")}`}
                >
                  <NavLink className="menu-link" to="/ImportLoads">
                    <span className="menu-text">{t("Loads")}</span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive("/ImportTrucker")}`}
                >
                  <NavLink className="menu-link" to="/ImportTrucker">
                    <span className="menu-text">{t("Truckers")}</span>
                  </NavLink>
                </li>
                {/*end::3 Level*/}
              </ul>
            </div>
          </li>
        ) : (
          ""
        )}
        {/*end::1 Level*/}
      </ul>
      {/*end::Header Nav*/}
    </div>
  );
}
